import { Box, Dialog, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
import { useState } from 'react'
import { handleCacheControl } from '../Helper/BlobHelper'
import { blobSAS } from '../Helper/BlobHelper'
import { useSnackbar } from "notistack";
import WEBGLPlayer from '../ProjectList/WEBGLPlayer';


const OpenAppList = (props) => {
    const [webglDialog, setWebglDialog] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [url, setUrl] = useState({});
    const [assetData, setAssetData] = useState({});

    const handleWebglDialog = () => {
        setAssetData({})
        setWebglDialog(false)
    }
    const setSource = async (data) => {
        let asset = data.asset_source.split(",");
        const obj = {};
        let sasToken = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
        for (let index = 0; index < asset.length; index++) {
            const element = asset[index];
            if (element.includes(".data.unityweb") || element.includes(".data.br") || element.includes(".data")) {
                obj.dataUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
            } else if (element.includes(".wasm.unityweb") || element.includes(".wasm.br") || element.includes(".wasm")) {
                obj.codeUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
            } else if (element.includes(".loader")) {
                obj.loaderUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
            } else if (element.includes(".framework.js.unityweb") || element.includes(".framework.js.br") || element.includes(".framework.js")) {
                obj.frameworkUrl = sasToken.fd_account_url + '/' + element + "?" + sasToken.read_only?.['project-executables'].sas_token;
            }
            obj.cacheControl = handleCacheControl;
        }
        let objkey = Object.keys(obj);
        if (objkey.length === 5) {
            setUrl(obj);
            assetData.version = data.asset_version_name;
            assetData.versionCode = data.asset_version_code;
            assetData.asset_id = data.id;
            assetData.version_id = data.asset_version_id;
            setWebglDialog(true);
        } else {
            enqueueSnackbar('Some files are missing', {
                variant: 'warning'
            });
        }
    };

    return (
        <div>
            <List dense={true}>
                {props.apps.map((data, index) => {
                    return (
                        <ListItemButton key={data.id || index} onClick={(e) => { setSource(data) }}>
                            <ListItem
                                secondaryAction={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {data.asset_version_head === 'webgl_edit' ?
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    px: 1.25,
                                                    py: 0.4,
                                                    borderRadius: 1,
                                                    color: 'success.dark',
                                                    backgroundColor: 'rgba(46, 125, 50, 0.10)',
                                                    border: '1px solid rgba(46, 125, 50, 0.22)',
                                                    fontWeight: 700,
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                EDITABLE
                                            </Typography> : null}
                                        {data.asset_version_name ?
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    px: 1.25,
                                                    py: 0.4,
                                                    borderRadius: 1,
                                                    color: 'secondary.main',
                                                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                    border: '1px solid rgba(25, 118, 210, 0.18)',
                                                    fontWeight: 600,
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                Latest: {data.asset_version_name}
                                            </Typography> : null}
                                    </Box>
                                }
                            >
                                <ListItemText
                                    primary={data.name}
                                    secondary={data.description ? data.description : null}
                                />
                            </ListItem>
                        </ListItemButton>
                    )
                })}
            </List>
            <Dialog fullWidth={true} maxWidth="xl" open={webglDialog}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ m: 2 }}>
                        <WEBGLPlayer url={url} close={handleWebglDialog} assetData={assetData} />
                    </Box>
                </Box>
            </Dialog>
        </div>
    )
}

export default OpenAppList